import React, {Component} from 'react';
import {connect} from 'react-redux';
import {map} from 'lodash';
import {reduxForm, Field} from 'redux-form';
import {required} from '../../../../common/components/form/common/fieldValidations';
import {Card, Button, Form, Grid, Menu} from 'semantic-ui-react';
import {InputField} from '../../../../common/components/form';
import {toUpperCase} from '../../../../common/util/fieldsNormalization';
import {Actions} from '../../../../common/actions';
import {MAIL_GROUP_FORM} from '../../../../common/forms';
import ExternalUsers from './ExternalUsers';
import InternalUsers from './InternalUsers';

const userTypes = {
  'internal': 'Usuarios Internos',
  'external': 'Usuarios Externos',
};

class MailGroupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeItem': 'internal',
    };
  }

  setCheckBoxValue = (e, {checked, name}) => {
    const {setMailGroupField} = this.props;
    const value = checked ? 'A' : 'I';
    setMailGroupField(name, value);
  };

  handleItemClick = (idx) => {
    this.setState({'activeItem': idx});
  };

  render() {
    const {activeItem} = this.state;
    const {handleSubmit, submitting, group, goBack, loading} = this.props;
  
    return (
      <Card raised fluid>
        <Form
          className="edit-mail-group-form"
          onSubmit={handleSubmit}
          loading={submitting || loading}
        >
          <div className="title-bar">
            <div className="title">
              <h2>
                {' '}
                {group ? 'Editar Grupo de Correo' : 'Añadir Grupo de Correo'}
              </h2>
              <div className="title-bar-actions">
                <Button
                  secondary
                  type="button"
                  onClick={goBack}
                  disabled={submitting}
                >
                  Cancelar
                </Button>
                <Button color="green" type="submit" loading={submitting}>
                  Guardar
                </Button>
              </div>
            </div>
          </div>
          <Card raised fluid className="mail-group-fields">
            <Grid textAlign="left">
              <Grid.Row>
                <Grid.Column textAlign="left" verticalAlign="middle" width={3}>
                  <h3>Nombre del Grupo</h3>
                </Grid.Column>
                <Grid.Column width={6}>
                  <Field
                    name="mailGroup"
                    component={InputField}
                    required
                    type="text"
                    maxLength={5}
                    normalize={toUpperCase}
                    validate={required}
                    disabled={!!group}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column textAlign="left" width={3}>
                  <h3>Descripción</h3>
                </Grid.Column>
                <Grid.Column width={6}>
                  <Field
                    name="description"
                    component={InputField}
                    required
                    normalize={toUpperCase}
                    type="text"
                    validate={required}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card>
        </Form>
        {group && (<Card raised fluid className='mail-group-users'>
          <Menu attached="top" color="red" tabular>
            {map(userTypes, (type, idx) => (
              <Menu.Item
                key={idx}
                name={type}
                color="red"
                active={activeItem === idx}
                onClick={() => this.handleItemClick(idx)}
              />
            ))}
          </Menu>
          {activeItem === 'internal' ? (
            <InternalUsers group={group} />
          ) : (
            <ExternalUsers group={group} />
          )}
        </Card>)}
      </Card>
    );
  }
}

export {MailGroupForm};

const form = reduxForm({
  'form': MAIL_GROUP_FORM.name,
})(MailGroupForm);

const mapStateToProps = (state) => {
  return {
    'loading': state.mailGroupForm.loading,
    'status': state.mailGroupForm.values.status,
  };
};

const {setMailGroupField} = Actions;

export default connect(mapStateToProps, {
  setMailGroupField,
})(form);
